export const STATUS_MAP = {
  NEW: { label: "Новый", textColor: "#000000", backgroundColor: "#FFFFFF" },
  IN_PROGRESS: {
    label: "В работе",
    textColor: "#FFFFFF",
    backgroundColor: "#52C41A",
  },
  CLOSED: {
    label: "Закрыт",
    textColor: "#FFFFFF",
    backgroundColor: "#BFBFBF",
  },
  PENDING_REVIEW: {
    label: "На проверке",
    textColor: "#FFFFFF",
    backgroundColor: "#FFC53D",
  },
  REJECTED: {
    label: "Отклонен",
    textColor: "#FFFFFF",
    backgroundColor: "#FF4D4F",
  },
  APPROVED: {
    label: "Одобрен",
    textColor: "#FFFFFF",
    backgroundColor: "#1890FF",
  },
  AWAITING_APPROVAL: {
    label: "На согласовании",
    textColor: "#FFFFFF",
    backgroundColor: "#91D5FF",
  },
  PREPAIRING_XML: {
    label: "Подготовка XML",
    textColor: "#FFFFFF",
    backgroundColor: "#D9D9D9",
  },
  SIGNING: {
    label: "На подписании",
    textColor: "#FFFFFF",
    backgroundColor: "#FAAD14",
  },
  SIGNED: {
    label: "Подписано",
    textColor: "#FFFFFF",
    backgroundColor: "#73D13D",
  },
  SENT_TO_GSN: {
    label: "Отправлено в ГСН",
    textColor: "#FFFFFF",
    backgroundColor: "#ADC6FF",
  },
  REGISTERED_IN_GSN: {
    label: "Зарегистрировано в ГСН",
    textColor: "#FFFFFF",
    backgroundColor: "#87E8DE",
  },
  INTERACTION_ERROR: {
    label: "Ошибка взаимодействия",
    textColor: "#FFFFFF",
    backgroundColor: "#722ED1",
  },
  DOCUMENT_ERROR: {
    label: "Ошибка документа",
    textColor: "#FFFFFF",
    backgroundColor: "#FF85C0",
  },
  GSN_REMARK: {
    label: "Замечание от ГСН",
    textColor: "#FFFFFF",
    backgroundColor: "#D48806",
  },
} as const;
